import { render } from "./EditPromoProduct.vue?vue&type=template&id=f29ef568&scoped=true&ts=true"
import script from "./EditPromoProduct.vue?vue&type=script&lang=ts"
export * from "./EditPromoProduct.vue?vue&type=script&lang=ts"

import "./EditPromoProduct.vue?vue&type=style&index=0&id=f29ef568&scoped=true&lang=scss"

import exportComponent from "/home/ubuntu/buildAgent/work/a701a23a46ecd31f/bookit-pms/Solution/Bookit.BO/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f29ef568"]])

export default __exports__